import { CustomElement } from "../../core/CustomElement";

import ko from "knockout";

export default class SearchPanelVM {
  $customElement: CustomElement;
  type: KnockoutObservable<string>;
  // keywordsFldLabel: KnockoutComputed<string>;
  dateFromFldLabel: KnockoutComputed<string>;
  isDiscussionsCategory: KnockoutComputed<boolean>;
  isIdeaLab: KnockoutComputed<boolean>;
  disabled: KnockoutObservable<boolean>;

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.type = ko.observable("discussions");
    // this.keywordsFldLabel = ko.pureComputed(() => {
    //   return this.type() === "ideas"
    //     ? "Keywords / Original Idea Number"
    //     : "Keywords";
    // });
    this.dateFromFldLabel = ko.pureComputed(() => {
      return "From";
    });
    this.isDiscussionsCategory = ko.pureComputed(() => {
      return this.type() === "discussions";
    });
    this.isIdeaLab = ko.pureComputed(() => {
      return this.type() === "ideas";
    });
    this.disabled = ko.observable();
  }
}
